import { Button, Dialog, TextField, Tooltip } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Typewriter } from "react-simple-typewriter";
import { toast } from "react-toastify";
import NYSC from "../../assets/images/nysc.png";
import NYSCOFFER from "../../assets/images/nyscoffer2.jpeg";
import { GlobalContext } from "../../context";
import { UpdateUserInfo } from "../../context/actions/auth";
import { FetchUserCoureses, loadSchedule } from "../../context/actions/courses";
import { fetchGamification } from "../../context/actions/gamification";
import { fetchMyClass } from "../../context/actions/attendance";
import Animator from "../Aminator/Animator";
import CircularProgress from "../Generic/CircularProgress";
import { useIsMobile } from "../hooks/useIsMobile";
import ActivitySidebar from "./ActivitySidebar";
import ClassAttendanceCard from "./ClassAttendanceCard";
import CourseBlackboard from "./CourseBlackboard";
import DailyQuestionCard from "./DailyQuestionCard";
import DashboardHeader from "./DashboardHeader";
import PaymentStatusBanner from "./PaymentStatusBanner";
import MakeupClassBanner from "./MakeupClassBanner";
import NyscDiscount from "../NyscDiscount";
import InstructorDashboard from "./InstructorDashboard";
import AdminOverview from "./AdminOverview";
import StaffHome from "./learn/staff/StaffHome";
import StudentHome from "./home/StudentHome";

export default function DashBoardNew() {
  const mobile = useIsMobile();
  const navigate = useNavigate();
  const targetRef = useRef(null);
  const targetRef1 = useRef(null);
  const [formData, setFormData] = useState({ telephone: "" });
  const [open, setOpen] = useState(false);
  const {
    authState: { data },
    authDispatch,
    scheduleDispatch,
    scheduleState,
    userCoursesDispatch,
  } = useContext(GlobalContext);

  const [loading, setLoading] = useState(false);
  const [gamification, setGamification] = useState(null);
  const [gamificationLoading, setGamificationLoading] = useState(true);
  const [myClass, setMyClass] = useState(null);

  const handleUpdatePhone = async () => {
    setLoading(true);
    const res = await UpdateUserInfo(formData, authDispatch);
    if (res) {
      toast.success("Phone Number Updated Successfully");
      setOpen(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadSchedule(scheduleDispatch);
    FetchUserCoureses(userCoursesDispatch);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!data?.user?.is_instructor && !data?.user?.is_admin && (data?.user?.telephone === null || data?.user?.telephone === "")) {
      setOpen(true);
    }
  }, [data]);

  useEffect(() => {
    fetchGamification().then((res) => {
      setGamification(res);
      setGamificationLoading(false);
    });
    if (!data?.user?.is_instructor) {
      fetchMyClass().then(setMyClass);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const question = gamification?.question ?? null;

  // Admins and instructors get the staff Home (new design); students get theirs below.
  if (data?.user?.is_admin || data?.user?.is_instructor) {
    return <StaffHome />;
  }

  return (
    <div>
      {/* Phone number dialog */}
      <Dialog fullWidth open={open} onClose={() => setOpen(false)}>
        <div style={{ width: "100%", background: "#fff", padding: "30px 20px" }}>
          <h1 style={{ marginBottom: 10 }}>Update Phone Number Field{" *"}</h1>
          <TextField
            value={formData.telephone}
            onChange={(e) => setFormData({ ...formData, telephone: e.target.value })}
            label="Phone Number"
            fullWidth
            style={{ marginBottom: 10 }}
          />
          <Button
            disabled={formData.telephone === "" || loading}
            onClick={handleUpdatePhone}
            size="large"
            fullWidth
            variant="contained"
          >
            {loading ? <CircularProgress /> : "Update Phone Number Details"}
          </Button>
        </div>
      </Dialog>

      {/* NYSC banner */}
      {data?.user?.is_nysc_student && (
        <div
          style={{
            minHeight: "30vh",
            background: `url(${NYSCOFFER})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div style={{ position: "absolute", inset: 0, background: "#000000B2" }} />
          <div
            className="innersection"
            style={{ width: mobile ? "100%" : "70%", position: "relative", zIndex: 1, color: "#fff" }}
          >
            <Animator delay={500} variant="fade">
              <h1
                style={{
                  fontSize: mobile ? 36 : 48,
                  fontWeight: 600,
                  letterSpacing: -0.5,
                  textShadow: "0px 4px 8px rgba(0,0,0,0.3)",
                }}
              >
                <Typewriter words={["Exclusive NYSC Scholarship Plan"]} />
              </h1>
            </Animator>
            <p>
              Take advantage of special discounts on career-boosting courses designed
              specifically for serving NYSC members.
            </p>
          </div>
        </div>
      )}

      {/* Payment status banners — students only */}
      {!data?.user?.is_instructor && !data?.user?.is_admin && <PaymentStatusBanner />}

      {/* Upcoming makeup class notification — students only */}
      {!data?.user?.is_instructor && !data?.user?.is_admin && <MakeupClassBanner />}

      {/* Students: the new Home (LMS revamp). Instructors keep the layout below. */}
      {!data?.user?.is_instructor ? (
        <>
          <StudentHome
            myClass={myClass}
            onClassChange={() => fetchMyClass().then(setMyClass)}
            gamification={gamification}
            gamificationLoading={gamificationLoading}
            onPointsChanged={setGamification}
          />
          {data?.user?.is_nysc_student && (
            <div ref={targetRef1} className="mx-auto w-full max-w-6xl px-4 pb-8 md:px-6">
              <h2 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16, color: "#001931" }}>
                NYSC Scholarship Plan
              </h2>
              <NyscDiscount targetRef={targetRef1} />
            </div>
          )}
        </>
      ) : (
      <>
      {/* Welcome header */}
      <header
        style={{
          background: "#f8fafc",
          color: "#0f172a",
          padding: mobile ? "60px 0 30px" : "80px 0 40px",
          borderBottom: "1px solid #e2e8f0",
        }}
      >
        <div className="innersection">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexDirection: mobile ? "column" : "row",
            }}
          >
            <div>
              {data?.user?.is_nysc_student && (
                <Tooltip describeChild title="You are enjoying NYSC discounts">
                  <img
                    src={NYSC}
                    alt=""
                    style={{ height: 50, objectFit: "contain", width: 100, marginBottom: 8 }}
                  />
                </Tooltip>
              )}
              <h1
                style={{
                  fontSize: mobile ? 28 : 38,
                  fontWeight: 800,
                  letterSpacing: "0.02em",
                  textTransform: "uppercase",
                  marginBottom: 12,
                  color: "#0f172a",
                }}
              >
                {data?.user?.firstname && (
                  <Typewriter words={[`Welcome Back, ${data.user.firstname}`]} />
                )}
              </h1>
              <p style={{ fontWeight: 400, color: "#64748b" }}>
                {data?.user?.is_instructor
                  ? "Manage your classroom, grade submissions, and track your students."
                  : "Hey champ, you have a lot to cover — let's get started!"}
              </p>
            </div>
            <div style={{ marginTop: mobile ? 24 : 0 }}>
              {data?.user?.is_instructor ? (
                <button
                  onClick={() => navigate("/dashboard/instructor/submissions")}
                  className="text-base rounded-xl text-white px-6 py-3 bg-[#d15424] hover:bg-[#b8451d] hover:scale-105 hover:shadow-lg hover:shadow-orange-500/20 active:scale-95 transition-all duration-300 cursor-pointer font-semibold shadow-md"
                  style={{ width: mobile ? "94vw" : "auto" }}
                >
                  Grade Submissions
                </button>
              ) : (
                <button
                  onClick={() => navigate("/courses/categories")}
                  className="text-base rounded-xl text-white px-6 py-3 bg-[#d15424] hover:bg-[#b8451d] hover:scale-105 hover:shadow-lg hover:shadow-orange-500/20 active:scale-95 transition-all duration-300 cursor-pointer font-semibold shadow-md"
                  style={{ width: mobile ? "94vw" : "auto" }}
                >
                  Add Courses
                </button>
              )}
            </div>
          </div>

          {!data?.user?.is_instructor && (
            <DashboardHeader
              schedule={scheduleState.data}
              onClick={() => {
                targetRef?.current?.scrollIntoView({ behavior: "smooth" });
              }}
            />
          )}
        </div>
      </header>

      {/* Main two-column layout */}
      <div
        ref={targetRef}
        style={{ background: "#f7f7f7", padding: mobile ? "24px 0" : "36px 0" }}
      >
        <div className="innersection">
          <div
            style={{
              display: "flex",
              gap: mobile ? 24 : 32,
              flexDirection: mobile ? "column" : "row",
              alignItems: "flex-start",
            }}
          >
            {/* Left: courses + daily question */}
            <div style={{ flex: 1, minWidth: 0 }}>
              {/* Live / Upcoming Class */}
              {!data?.user?.is_instructor && myClass && (
                <div style={{ marginBottom: 28 }}>
                  <h2 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16, color: "#001931" }}>
                    {myClass.status === "live" ? "Live Class" : "Next Class"}
                  </h2>
                  <ClassAttendanceCard
                    classData={myClass}
                    onAttended={() => fetchMyClass().then(setMyClass)}
                  />
                </div>
              )}

              {/* Daily Question of the Day */}
              {!data?.user?.is_instructor && (
                <div style={{ marginBottom: 28 }}>
                  <h2 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16, color: "#001931" }}>
                    Today's Challenge
                  </h2>
                  {gamificationLoading ? (
                    <div className="bg-white rounded-2xl border border-gray-100 p-6">
                      <div className="h-4 bg-gray-100 rounded w-3/4 mb-3 animate-pulse" />
                      <div className="h-4 bg-gray-100 rounded w-1/2 mb-6 animate-pulse" />
                      {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="h-10 bg-gray-100 rounded-xl mb-2 animate-pulse" />
                      ))}
                    </div>
                  ) : question ? (
                    <DailyQuestionCard
                      question={question}
                      onPointsChanged={setGamification}
                    />
                  ) : (
                    <div className="bg-white rounded-2xl border border-gray-100 p-6 text-center">
                      <p className="text-4xl mb-3">🧠</p>
                      <p className="text-sm font-medium text-gray-600">No question today</p>
                      <p className="text-xs text-gray-400 mt-1">Check back tomorrow!</p>
                    </div>
                  )}
                </div>
              )}

              {data?.user?.is_admin ? (
                <AdminOverview />
              ) : data?.user?.is_instructor ? (
                <InstructorDashboard />
              ) : (
                <>
                  <h2 style={{ fontSize: 22, fontWeight: 600, marginBottom: 20, color: "#001931" }}>
                    My Courses
                  </h2>
                  <CourseBlackboard />
                </>
              )}

              {/* NYSC discount section */}
              {data?.user?.is_nysc_student && (
                <div ref={targetRef1} style={{ marginTop: 36 }}>
                  <h2 style={{ fontSize: 22, fontWeight: 600, marginBottom: 16, color: "#001931" }}>
                    NYSC Scholarship Plan
                  </h2>
                  <NyscDiscount targetRef={targetRef1} />
                </div>
              )}
            </div>

            {/* Right: activity sidebar — students only */}
            {!mobile && !data?.user?.is_instructor && (
              <div style={{ width: 320, flexShrink: 0 }}>
                <ActivitySidebar
                  gamification={gamification}
                  gamificationLoading={gamificationLoading}
                />
              </div>
            )}
          </div>

          {/* On mobile, show sidebar below — students only */}
          {mobile && !data?.user?.is_instructor && (
            <div style={{ marginTop: 24 }}>
              <ActivitySidebar
                gamification={gamification}
                gamificationLoading={gamificationLoading}
              />
            </div>
          )}
        </div>
      </div>
      </>
      )}
    </div>
  );
}
